import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function GeometricShapes() {
  const { scrollYProgress } = useScroll();
  
  const shapes = [
    { type: 'circle', gradient: 'from-primary to-accent-yellow', size: 300, left: '-5%', top: '10%', delay: 0 },
    { type: 'square', gradient: 'from-accent-blue to-primary', size: 200, left: '80%', top: '30%', delay: 0.2 },
    { type: 'circle', gradient: 'from-accent-yellow to-primary', size: 250, left: '60%', top: '60%', delay: 0.4 },
    { type: 'square', gradient: 'from-primary to-accent-blue', size: 150, left: '10%', top: '70%', delay: 0.6 },
  ];

  const y = useTransform(scrollYProgress, [0, 1], [0, 200]);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {shapes.map((shape, index) => (
        <motion.div
          key={index}
          className="absolute"
          style={{
            left: shape.left,
            top: shape.top,
            width: shape.size,
            height: shape.size,
            y,
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ 
            opacity: [0.1, 0.2, 0.1],
            scale: [0.8, 1, 0.8],
            rotate: shape.type === 'square' ? [0, 90, 0] : [0, 0, 0],
          }}
          transition={{
            duration: 8,
            delay: shape.delay,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <div 
            className={`w-full h-full bg-gradient-to-br ${shape.gradient} ${
              shape.type === 'circle' ? 'rounded-full' : ''
            } blur-2xl`}
            style={{ opacity: 0.15 }}
          />
        </motion.div>
      ))}
    </div>
  );
}